module.exports = __webpack_public_path__ + "img/cooperative1_logo4.ff90b887.jpg";